import type {
  TerraService,
  ITerraService,
  LinkTakaMembershipRequest,
  LinkTakaMembershipResponse,
  InstallmentTermsResponse,
  Response,
  RegisterMembershipRequest,
  GetLoyaltyMemberInfoResponse,
} from '@teko/terra-bff';

class TerraServiceWrapper implements ITerraService {
  private baseUrl: string;
  private servicePromise: Promise<TerraService> = null;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private async initializeService() {
    if (!this.servicePromise) {
      this.servicePromise = import('@teko/terra-bff').then(
        (mod) => new mod.TerraService(this.baseUrl),
      );
    }
    return this.servicePromise;
  }

  async linkTakaMembership(
    body: LinkTakaMembershipRequest,
    loyaltyClientId: string,
  ): Promise<LinkTakaMembershipResponse> {
    const service = await this.initializeService();
    return service.linkTakaMembership(body, loyaltyClientId);
  }

  async getInstallmentTerms(
    merchantMethodCode: string,
    amount: number,
  ): Promise<InstallmentTermsResponse> {
    const service = await this.initializeService();
    return service.getInstallmentTerms(merchantMethodCode, amount);
  }

  async registerMembership(
    request: RegisterMembershipRequest,
    loyaltyClientId: string,
  ): Promise<Response> {
    const service = await this.initializeService();
    return service.registerMembership(request, loyaltyClientId);
  }

  async getLoyaltyMemberInfo(
    loyaltyClientId: string,
    phone?: string,
    memberQrCode?: string,
  ): Promise<GetLoyaltyMemberInfoResponse> {
    const service = await this.initializeService();
    return service.getLoyaltyMemberInfo(loyaltyClientId, phone, memberQrCode);
  }
}

export default TerraServiceWrapper;
